import React, { useEffect, useRef, useState } from 'react';
import store from 'src/storeWire';
import { system_notification } from 'src/store/slice/system';
import { useBOMStore } from "../../../../hooks/bom";
import { isObject } from "underscore";
import PriceTable from "../../../../component/Global/Cart/PriceTable";
import DisplayQtyMinQtyMult from "../../../../component/Product/DisplayQtyMinQtyMult";
import DisplayLifeCycleRisk from "../../../../component/BOM/DisplayLifeCycleRisk";
import { useDispatch, useSelector } from "react-redux";
import Common from '../../Common';
import { useSearchParams } from 'react-router-dom';
import BomRemovePart from "./BomRemovePart";
import useTabDisplayStatus from "./hook";
import { useAxiosIndicatorCheck } from "../../../../store/hook/useAxiosIndicatorCheck";
import {
    load_all_selected_fields,
    remove_all_selected_fields,
    toggle_single_selected_fields

} from "src/store/slice/model/BOM/BOMExactMatch";
import QuantityPicker from "../../../../component/Global/BOM/QuantityPicker";
import useReduxState from "../../../../hooks/useReduxState";
import FactoryLeadTimeDisplay from 'src/component/Product/FactoryLeadTimeDisplay';
import datasheet2 from "src/assets/images/icon-file-pdf.png"
import Product from '@system/config/product';
import { SET_quantity_exact_match_tab_by_bomDetailId } from 'src/store/slice/model/BOM';
import RefreshStockButton from 'src/pages/ProductListing/RefreshStockButton';
import AddToCart from 'src/component/Global/Cart/AddToCart';
import $ from "jquery";
import "floating-scroll";
import AxiosSingletonLoader from "../../../../component/AxiosSingletonLoader";
import Helper from 'src/support/Helper';
import ShowMoreLess from "../../../../component/Product/ShowMoreLess";
import CustomerPartNumberOptions from "../../../../component/Global/Cart/CustomerPartNumberOptions";
import useDebounce from "../../../../hooks/useDebounce";
import BomExactMatchValidation from "./BomExactMatchValidation";
import produceClone from "../../../../helper/produceClone";
import ProductLegends from 'src/pages/ProductListing/ProductLegends';
import Constants from 'src/support/Constants';
import { useCartStore } from 'src/hooks/cart';
import { useProductInventoryStore } from 'src/hooks/productInventory';
import { useProductPricingStore } from 'src/hooks/productPricing';
import ProductPricingRepository from 'src/repository/ProductPricingRepository';
import BOMRepository from 'src/repository/BOMRepository';
import AxiosIndicatorRunTimeLoader from 'src/component/AxiosIndicatorRunTimeLoader';
import System from 'src/helper/system';
import stickyTableHeader from 'src/helper/stickyTableHeader';
import ReusableDiv from 'src/support/ReusableDiv';
import useCheckAuthPermissions from 'src/hooks/component/useCheckAuthPermissions';
import liveAuth from 'src/helper/liveAuth';
import { NonLoginSignInButton } from 'src/reusable/global';


const BomExactMatchTable = (props) => {
    const [__check] = useAxiosIndicatorCheck();
    const [searchParams] = useSearchParams();
    const axios_indicator = useSelector((state) => state.entities.system.axios_indicator);
    const refLoadMore = useRef();
    const [checkAll, setCheckAll] = useState(false);

    useEffect(() => {
        setTimeout(() => {
            $(".floating-table").floatingScroll("init");
        }, 2000)
    }, [axios_indicator]);

    const [top, SetTop] = useReduxState({}, 'BOM_DETAIL_TOP_PARAM_FOP_LIMIT', true);
    const [quantityUpdateCallbackRunTime, SetQuantityUpdateCallbackRunTime] = useDebounce(false, 300);
    const [{ bom_detail_by_bom_id_type, bomSortByUpdatedDate }, { get_bom_detail_by_bom_id_with_type }, {  update_quantity_by_bom_detail_by_id, update_customer_part_number_by_bom_detail_by_id }] = useBOMStore();
    const [displayStatus] = useTabDisplayStatus('Exact');
    const dispatch = useDispatch(false);
    const dynamic_field_activated = useSelector((state) => state.entities.model_BOM_BOMFieldActivated.BomDetail.ExactMatchPage.dynamic_field_activated)
    const bomDetailByBomID = useSelector((state) => state.entities.model_BOM.bomDetailByBomID)
    const selected_fields = useSelector((state) => state.entities.model_BOM_BOMExactMatch.selected_fields)
    const [{ bomPricingList }, { fetch_product_pricing_list }, { }] = useProductPricingStore();
    const [{ inventoryList }, { fetch_product_inventory_list, get_inventory_by_id }, { }] = useProductInventoryStore();
    const [BomTabList__Component__Loader] = useReduxState(searchParams.get(Common.param_key_BomTabList) ? searchParams.get(Common.param_key_BomTabList) : Common.default_component_BomTabList.param_value, Common.redux_key_BomTabList, 'BomTabList__Component__Loader');
    const [loadfetchInventoryFromServer, set_loadfetchInventoryFromServer] = useState(true);
    const inventory = inventoryList;
    const pricing = bomPricingList;
    const [productSelected] = useReduxState({}, 'setAutoCompleteProductSelected')
    const [isQuicklyPart, setIsQuicklyPart] = useReduxState(false, 'setIsQuicklyPart');
    const [isInternalUser, setIsInternalUser] = useState(false);
    const [sortBy, setSortBy] = useState('');
    const [sortOrder, setSortOrder] = useState('');
    const [ascDesField, setAscDesField] = useState({});


    useEffect(() => {
        let internalUser = System.CheckInternalUser()
        setIsInternalUser(internalUser)
    }, []);

    const [_check_p] = useCheckAuthPermissions();

    useEffect(() => {
        if (Object.entries(productSelected).length > 0) {
            setIsQuicklyPart(true)
            SetTop({
                NoMatch: { top: 20 },
                Multiple: { top: 20 },
                Exact: { top: 20 }
            })
        }
    }, [productSelected]);

    const onSelectAll = (checked) => {
        setCheckAll(checked)
        onCheckAll(checked)
    }


    useEffect(() => {
        async function fetchHere() {
            if (bom_detail_by_bom_id_type?.Exact?.records && Object.entries(bom_detail_by_bom_id_type.Exact.records).length > 0 && !quantityUpdateCallbackRunTime) {
                await Promise.all([
                    fetchInventoryFromServer(),
                    fetchPricingFromServer()
                ]).then((resp) => {
                }).catch(() => { });

            }
            if (quantityUpdateCallbackRunTime) {
                SetQuantityUpdateCallbackRunTime(false)
            }
        }
        fetchHere()
    }, [bom_detail_by_bom_id_type?.Exact?.records]);

    useEffect(() => {
        setTimeout(() => {
            if (top?.Exact?.top > 20) {
                let topData = top?.Exact?.top
                document.getElementById('line' + (topData - 11)).scrollIntoView();
            }
        }, 5000);
    }, [top?.Exact?.top]);

    const getFilterData = (dataObj, isSingleObj = 'no') => {
        if (isSingleObj === 'yes') {
            const filterRes = Object.keys(dataObj).reduce((result, key) => {
                if (key.includes('bomDetailId') || key.includes('ERPPartNumber') || key.includes('quantity') || key.includes('product') || key.includes('product_contract_id') || key.includes('isDeleted') || key.includes('customerPartNumber') || key.includes('cpnTypeName') || key.includes('manualCPN')) {
                    result[key] = dataObj[key];
                }
                return result;
            }, {});
            return filterRes
        } else {
            const filterRes = Object.entries(dataObj).reduce((res, v) => {
                const result = Object.keys(v[1]).reduce((result, key) => {
                    if (key.includes('bomDetailId') || key.includes('ERPPartNumber') || key.includes('quantity') || key.includes('product') || key.includes('product_contract_id') || key.includes('isDeleted') || key.includes('customerPartNumber') || key.includes('cpnTypeName') || key.includes('manualCPN')) {
                        result[key] = v[1][key];
                    }
                    return result;
                }, {});
                res[v[0]] = result
                return res
            }, {})
            return filterRes
        }
    }
    const onCheckAll = (checked) => {
        if (checked) {
            if (bom_detail_by_bom_id_type.Exact.records && Object.entries(bom_detail_by_bom_id_type.Exact.records).length > 0) {
                const filterData = getFilterData(bom_detail_by_bom_id_type.Exact.records)
                dispatch(load_all_selected_fields({ selected_fields: filterData }))
            }
        } else {
            dispatch(remove_all_selected_fields())
        }

    };

    const updateCpnBom = async (SELECTED_CUSTOMER_PART_NUMBER, SELECTED_TYPE, bom) => {
        let bomData = produceClone(bom);

        /**
         * set cpnType and cpn , manual cpn value based on selection for checkbox select
         * Author: Devanshi Patel
         */
        bomData.cpnTypeName = SELECTED_TYPE
        bomData.customerPartNumber = SELECTED_TYPE === Constants.cpnTypes.CPN ? SELECTED_CUSTOMER_PART_NUMBER : bomData.customerPartNumber
        bomData.manualCPN = SELECTED_TYPE === Constants.cpnTypes.MANUALCPN ? SELECTED_CUSTOMER_PART_NUMBER : bomData.manualCPN
        /**
         * Owner : Trilok
         * Date  : 08/02/2023
         * Note  : Accessing current top value to fetch all records upto top value.
         */
        let top_here = 10;
        if (top[Common.chain_BomTabList[BomTabList__Component__Loader].api_fetch_type] !== undefined &&
            top[Common.chain_BomTabList[BomTabList__Component__Loader].api_fetch_type].top
        ) {
            top_here = top[Common.chain_BomTabList[BomTabList__Component__Loader].api_fetch_type].top;
        }
        top_here = top_here === 10 ? 20 : (top_here - 1);

        let param = {
            bomId: bomData.bomId,
            matchType: Common.chain_BomTabList[BomTabList__Component__Loader].api_fetch_type,
            top: top_here,
            skip: 0
        }

        if (bomSortByUpdatedDate) {
            param.sortColumn = "updated_date"
            param.sortOrder = "desc"
        }

        await get_bom_detail_by_bom_id_with_type(param);
        if (selected_fields && selected_fields[bomData.bomDetailId] !== undefined && selected_fields[bomData.bomDetailId].bomDetailId == bomData.bomDetailId) {
            const filterData = getFilterData(bomData, 'yes')
            dispatch(toggle_single_selected_fields({ ...filterData, forceAdd: true }))
        }
    }
    const setStatusOfForFieldActivated = (singleDownloadColumnList) => {
        const filterData = getFilterData(singleDownloadColumnList, 'yes')
        dispatch(toggle_single_selected_fields({ ...filterData }))
    };

    const getStatusOfForFieldActivated = (singleDownloadColumnList) => {
        if (selected_fields && selected_fields[singleDownloadColumnList.bomDetailId] !== undefined
        ) {
            return selected_fields[singleDownloadColumnList.bomDetailId];
        }
        return false
    };

    const fetchInventoryFromServer = async () => {
        set_loadfetchInventoryFromServer(true);
        if (bom_detail_by_bom_id_type.Exact.records && Object.entries(bom_detail_by_bom_id_type.Exact.records).length > 0) {
            let params = [];
            Object.entries(bom_detail_by_bom_id_type.Exact.records).map((v) => {
                !v[1].product?.ERPPartNumberModified && params.push({
                    sboat: v[1].product.Sboat,
                    ERPManufacturerCode: v[1].product.ERPManufacturerCode,
                    ERPPartNumber: v[1].product.ERPPartNumber
                })
            });
            await fetch_product_inventory_list(params)
            set_loadfetchInventoryFromServer(false);
        }
    };

    const fetchPricingFromServer = async () => {
        if (bom_detail_by_bom_id_type.Exact.records &&
            Object.entries(bom_detail_by_bom_id_type.Exact.records).length > 0) {
            let params = [];
            Object.entries(bom_detail_by_bom_id_type.Exact.records).map((v) => {
                params.push({
                    partNumber: v[1]?.product?.ERPPartNumberModified ? '' : v[1].product.ERPPartNumber,
                    erpManufacturerCode: v[1].product.ERPManufacturerCode,
                    erpMfrPartNumber: v[1].product.ERPMFRPartNumber,
                    WebCode: v[1].product.WebCode,
                    ObsoleteFlag: v[1].product.ObsoleteFlag,
                    // Qas: getInventory(v[1].product.ERPPartNumber)?.qas,
                    customerPartNumber: (v[1].cpnTypeName === Constants.cpnTypes.MANUALCPN ? (v[1].manualCPN ? v[1].manualCPN : (v[1]?.product?.CustomerPartNumbers.length > 0 ? '*' : '')) : v[1].customerPartNumber)
                })

            });

            let paramSet = await new ProductPricingRepository().getPricingParams(params);
            await fetch_product_pricing_list(paramSet)
        }
    };

    const getCPN = (v) => {
        // return (v.cpnTypeName === Constants.cpnTypes.MANUALCPN ? v.manualCPN : v?.customerPartNumber ? v.customerPartNumber.toUpperCase() : v.customerPartNumber)
        return v.cpnTypeName === Constants.cpnTypes.MANUALCPN ? Helper.toUpperCase(v.manualCPN) : Helper.toUpperCase(v?.customerPartNumber)
    }

    const getInventory = (ERPPartNumber) => {
        // if (inventory[ERPPartNumber] !== undefined) {
        //     return inventory[ERPPartNumber];
        // }
        // return {
        //     qas: 0,
        //     quantity: 0
        // };
        return get_inventory_by_id(ERPPartNumber)
    };

    const getPricing = (ERPMFRPartNumber, ERPPartNumber, customerPartNumber, cpnType, ERPPartNumberModified) => {
        customerPartNumber = cpnType === Constants.cpnTypes.MANUALCPN && !customerPartNumber ? '*' : customerPartNumber
        ERPPartNumber = ERPPartNumberModified ? '' : ERPPartNumber;
        if (pricing[ERPMFRPartNumber + '-' + ERPPartNumber + '-' + customerPartNumber]) {
            return pricing[ERPMFRPartNumber + '-' + ERPPartNumber + '-' + customerPartNumber];
        } else if (pricing[ERPMFRPartNumber + '-' + ERPPartNumber]) {
            return pricing[ERPMFRPartNumber + '-' + ERPPartNumber];
        }
        return [];
    };

    useEffect(() => {
        if (quantityUpdateCallbackRunTime) {
            quantityUpdateCallback(quantityUpdateCallbackRunTime.bomDetail, quantityUpdateCallbackRunTime.q);
        }
    }, [quantityUpdateCallbackRunTime]);
    const quantityUpdateCallback = (bomDetail, q) => {
        bomDetail = produceClone(bomDetail);
        bomDetail.quantity = q;
        dispatch(SET_quantity_exact_match_tab_by_bomDetailId({ bomDetailId: bomDetail.bomDetailId, quantity: q }))
        /**
         * Send quantity 0 when clear whole quantity
         * Author: Devanshi Patel
         */
        update_quantity_by_bom_detail_by_id({ bomDetailId: bomDetail.bomDetailId, quantity: q === '' ? 0 : q })
        setTimeout(() => {
            const filterData = getFilterData(bomDetail, 'yes')
            dispatch(toggle_single_selected_fields({ ...filterData, forceAdd: true }))
        }, 300)
    }

    const [{ CART_BEFORE_TO_SEND_SERVER, CART_CUSTOMER_PART_NUMBER_BEFORE_TO_SEND_SERVER }, { }, { }] = useCartStore();
    const validatePartNumberForCart = (bomDetail) => {
        // Below code will execute only for the EOL/Obsolete part
        if (bomDetail && bomDetail.product &&
            (bomDetail.product.EndOfLifeFlag === true ||
                bomDetail.product.ObsoleteFlag === true)) {
            return new BomExactMatchValidation(bomDetail, getPricing(bomDetail.product.ERPMFRPartNumber, bomDetail.product.ERPPartNumber, getCPN(bomDetail), bomDetail.cpnTypeName, bomDetail.product.ERPPartNumberModified), getInventory(bomDetail.product.ERPPartNumber), CART_BEFORE_TO_SEND_SERVER).validatePartNumberForCart();
        }
        return true;
    }

    /**
     * Owner : Trilok
     * Date  : 08/02/2023
     * Note  : To Refresh table for scroll position update.
     */
    const getLatestKey = () => {
        if (dynamic_field_activated !== undefined && dynamic_field_activated !== null) {
            if (dynamic_field_activated[bomDetailByBomID?.bomId] !== undefined) {
                return Object.keys(dynamic_field_activated[bomDetailByBomID.bomId]).length;
            }
            return "";
        }
        return ""
    }

    const checkCartValid = (v) => {
        let validCartResult = new BOMRepository().cartValid(v, getPricing(v.product.ERPMFRPartNumber, v.ERPPartNumber, getCPN(v), v.cpnTypeName, v.ERPPartNumberModified), getInventory(v.product.ERPPartNumber))
        return validCartResult.isCartValidQty
    }

    /**
     * Bug    #  : 9670
     * Change #  : Display download message on download
     * Change by : PN
     * Date      : 4 Aug 2023
     */
    const showDownloadMessage = () => {
        System.alert(Constants.downloadMsg, 'success')
    }

    /**
     * Ticket #  : 10890
     * Change #  : Common function called for sticky header
     * Change by : Pankaj
     * Date      : 29 Aug,2023
     */
    useEffect(() => {

        let refreshStockButton;
        let isDisplayFixedHeader = false;
        let callback;

        if (bom_detail_by_bom_id_type && bom_detail_by_bom_id_type.Exact && Object.entries(bom_detail_by_bom_id_type.Exact.records).length > 0) {
            const sort = null;
            const tableElement = document?.getElementById("bomexactmatch-table");
            // headerHeght contains height where we need to display static header
            // local
            // const headerHeight =  document?.getElementsByTagName("header") ? document?.getElementsByTagName("header")[0]?.clientHeight :65;
            //sbx
            let headerHeight = document?.getElementsByClassName("navbar navbar-default white") ? document?.getElementsByClassName("navbar-default")[0]?.clientHeight + 1 : 156;

            // Admin Toolbar header height adjustment
            const adminToolBarHeight = document?.getElementsByClassName("wpToolbarActionBar wpToolbarCommon")?.length > 0 ? document?.getElementsByClassName("wpToolbarActionBar wpToolbarCommon")[0]?.clientHeight : 0;

            if (adminToolBarHeight > 0) {
                headerHeight = headerHeight + adminToolBarHeight;
            }
            // is used to track only one header will display at a moment
            // extra function attach 
            document.addEventListener("scroll", (ScrollEvent) => {
                // current table position from top
                const tablePosition = tableElement && tableElement.getBoundingClientRect() ? tableElement.getBoundingClientRect().y : false;
                const paginationPosition = document?.querySelectorAll("div.pagination-row") ? document?.querySelectorAll("div.pagination-row")[0]?.getBoundingClientRect()?.y : false;
                // mainCheckBox = document.getElementsByClassName('parent-check-input').length > 2 ? document.getElementsByClassName('parent-check-input')[document.getElementsByClassName('parent-check-input').length - 1] : false;

                if (tablePosition && headerHeight > tablePosition && isNaN(paginationPosition) === false && (Number(headerHeight) + 40 <= Number(paginationPosition)) && !isDisplayFixedHeader) {
                    //function used to display header clone after actual header height is less than headerHeight from top
                    // function(id, headerHeight,  tableContainerId, firstColumnsFixed, sort)
                    callback = stickyTableHeader("bomexactmatch-table", headerHeight, "sticky-table-wrapper", 1, sort)
                    isDisplayFixedHeader = true;
                    refreshStockButton = document.getElementsByClassName("refresh-link")
                    refreshStockButton[refreshStockButton.length - 1].addEventListener("click", fetchInventoryFromServer);

                    if (document.getElementsByClassName('parent-check-input').length > 0) {
                        document.getElementsByClassName('parent-check-input')[document.getElementsByClassName('parent-check-input').length - 1].addEventListener('change', (evt) => onSelectAll(evt.currentTarget.checked))
                    }
                } else {
                    if ((headerHeight < tablePosition || (Number(paginationPosition) <= Number(headerHeight) + 40)) && isDisplayFixedHeader && callback) {
                        // switch variable to false for track that clone header hide
                        isDisplayFixedHeader = false;
                        // check element exist before remove event listeners
                        if (document.getElementsByClassName('parent-check-input').length > 0 && onSelectAll) {
                            document.getElementsByClassName('parent-check-input')[document.getElementsByClassName('parent-check-input').length - 1]?.removeEventListener("change", onSelectAll);
                        }
                        // check element exist before remove event listeners
                        if (refreshStockButton && refreshStockButton[refreshStockButton.length - 1] && fetchInventoryFromServer) {
                            refreshStockButton[refreshStockButton.length - 1]?.removeEventListener("click", fetchInventoryFromServer);
                        }

                        // function used to remove the clone header
                        if (Object.prototype.toString.call(callback) == '[object Function]') {
                            callback();
                        }
                    }
                }
            })
            return () => {
                if (callback) {
                    // switch variable to false for track that clone header hide
                    isDisplayFixedHeader = false;
                    // check element exist before remove event listeners
                    if (document.getElementsByClassName('parent-check-input').length > 0 && onSelectAll) {
                        document.getElementsByClassName('parent-check-input')[document.getElementsByClassName('parent-check-input').length - 1]?.removeEventListener("change", onSelectAll);
                    }
                    // check element exist before remove event listeners
                    if (refreshStockButton && refreshStockButton[refreshStockButton.length - 1] && fetchInventoryFromServer) {
                        refreshStockButton[refreshStockButton.length - 1]?.removeEventListener("click", fetchInventoryFromServer);
                    }
                    // function used to remove the clone header
                    callback();
                    __check(['BOM_TAB_API_CALL', 'BOM_API_CALL']).status && window.scrollTo(0, 0)
                }
            }
            // callBackResult = stickyTableCommon('bomexactmatch-table',null,true,true,onSelectAll)
        }
    }, [bom_detail_by_bom_id_type, __check(['BOM_TAB_API_CALL', 'BOM_API_CALL']).status])

    const toggleOrderBy = async (columnName) => {
        if (ascDesField.hasOwnProperty(columnName)) {
            ascDesField[columnName] = ascDesField[columnName] === 'ASC' ? 'DESC' : 'ASC'
            setAscDesField(ascDesField)
        } else {
            ascDesField[columnName] = 'ASC'
            setAscDesField(ascDesField)
        }
        setSortBy(columnName)
        setSortOrder(ascDesField[columnName])

        let top_here = 10;
        if (top[Common.chain_BomTabList[BomTabList__Component__Loader].api_fetch_type] !== undefined &&
            top[Common.chain_BomTabList[BomTabList__Component__Loader].api_fetch_type].top
        ) {
            top_here = top[Common.chain_BomTabList[BomTabList__Component__Loader].api_fetch_type].top;
        }
        top_here = top_here === 10 ? 20 : (top_here - 1);

        let param = {
            bomId: System.getParams().bomId,
            matchType: Common.chain_BomTabList[BomTabList__Component__Loader].api_fetch_type,
            top: top_here,
            skip: 0,
            sortColumn: columnName,
            sortOrder: ascDesField[columnName]
        }

        await get_bom_detail_by_bom_id_with_type(param);
    };

    const getOrderByClass = (columnName) => {
        if (sortBy === columnName && ascDesField.hasOwnProperty(columnName)) {
            return 'sorting sorting_' + ascDesField[columnName].toLowerCase()
        }
        return 'sorting'
    };

    const isGuestFullRights = () => {
        return (_check_p('PDG_ADD_TO_CART').status === true &&
            _check_p('PDG_ADD_TO_BOM').status === true &&
            _check_p('PDG_CLICK_TO_QUOTE').status === true ? true : false);
    }

    const validateNonLoginUser = () => {
        if (!liveAuth.check()) {
            return true;
        }
        if (liveAuth.check() && isGuestFullRights() === false) {
            return true;
        }
        return false;
    }

    return (
        <>
            <div className="tab-content p-0">
                <div id='sticky-table-wrapper'
                    key={"table-refresh" + getLatestKey()}
                    className={__check(['BOM_TAB_API_CALL', 'BOM_API_CALL']).status ? "floating-table table-responsive loader-wrapper-outer minh350 mb-0" : "floating-table table-responsive  mb-0 sticky-table-wrapper"}>
                    {__check(['BOM_TAB_API_CALL', 'BOM_API_CALL'], { overlay: true }).render}
                    <table id='bomexactmatch-table' className="bs5 table table-bordered table-exact-match">
                        <thead style={{
                            display: displayStatus() ? '' : 'none'
                        }}>
                            <tr>
                                <th className="w-85"></th>
                                <th className="text-nowrap">
                                    <div className="form-check font-15 d-flex align-items-center ps-0">
                                        <input type="checkbox" checked={checkAll} className="form-check-input parent-check-input ps-0 ms-0"
                                            onClick={(e) => {
                                                setCheckAll(e.target.checked)
                                                onCheckAll(e.target.checked)
                                            }}
                                            onChange={() => {
                                            }} />
                                        <label className="form-check-label mt-0" htmlFor="customCheck1"></label>
                                    </div>
                                </th>
                                <th className="text-nowrap w200">Part Number</th>
                                <th className="text-nowrap w220">Manufacturer Part Number</th>
                                <th className="text-nowrap w220">Customer Part Number <i className="fa fa-info-circle ms-1" /></th>
                                <th className="text-nowrap w150">Quantity</th>
                                <th className="text-nowrap w160">Price</th>
                                <th className="text-nowrap w220">Availability
                                    <RefreshStockButton fetchInventoryFromServer={async () => {
                                        fetchInventoryFromServer();
                                    }} />
                                </th>
                                <th className="text-nowrap">manufacturer</th>
                                <th className="text-nowrap">Information</th>
                                {isInternalUser &&
                                    <th className={'text-nowrap ' +
                                        getOrderByClass('design_win_flag')
                                    }
                                        onClick={async () => {
                                            await toggleOrderBy('design_win_flag')
                                        }}>Design Registerable</th>
                                }
                                {dynamic_field_activated[bomDetailByBomID.bomId] !== undefined &&
                                    dynamic_field_activated[bomDetailByBomID.bomId] &&
                                    isObject(dynamic_field_activated[bomDetailByBomID.bomId]) &&
                                    Object.entries(dynamic_field_activated[bomDetailByBomID.bomId]).map((v) => (
                                        <th key={v[1].columnName} className="text-nowrap">{v[1].fileColumnName}</th>
                                    )
                                    )}
                            </tr>
                        </thead>
                        <tbody>
                            {displayStatus() &&
                                Object.entries(bom_detail_by_bom_id_type.Exact.records).map((v, i) => (
                                    <React.Fragment key={v[1].sequenceNumber}>
                                        <tr className="align-top" key={v[1].sequenceNumber} id={'line' + i}>
                                            <td>
                                                <span className="index-count">{v[1].sequenceNumber}</span>
                                            </td>
                                            <td>
                                                {v[1].isDeleted === false &&
                                                    <div className="form-check font-12 d-flex align-items-center ps-0 minh-0">
                                                        <input type="checkbox" className="form-check-input ps-0 ms-0 mt-0"
                                                            onChange={(e) => {
                                                                setStatusOfForFieldActivated(v[1])
                                                            }}
                                                            checked={getStatusOfForFieldActivated(v[1])}
                                                            id={'checkBox' + v[1].bomDetailId}
                                                            name={'checkBox' + v[1].bomDetailId} />
                                                        <label className="form-check-label mt-0"
                                                            htmlFor={'checkBox' + v[1].bomDetailId}
                                                            onChange={(e) => {
                                                                setStatusOfForFieldActivated(v[1])
                                                            }} />
                                                    </div>
                                                }
                                            </td>
                                            {v[1].isDeleted === true &&
                                                <td>
                                                    Deleted: {v[1].manufacturerPartNumber}
                                                </td>
                                            }
                                            {v[1].isDeleted === false &&
                                                <React.Fragment>
                                                    <td>
                                                        <div className="d-flex w-100 justify-content-between align-items-center">
                                                            <div>
                                                                {v[1].partNumberRaw}
                                                            </div>

                                                            <BomRemovePart bomId={v[1].bomId} bomDetailId={v[1].bomDetailId}
                                                                singleBomDetail={v[1]} exact_match={true} removeType={"exactMatches"} />
                                                        </div>
                                                        {validatePartNumberForCart(v[1]) === false && v[1].product.EndOfLifeFlag === false &&
                                                            <span className='mandatory'><br />Ineligible for Quote/Cart</span>
                                                        }

                                                        {(v[1].product !== undefined && v[1].bom_alternative_object !== undefined &&
                                                            v[1].bom_alternative_object.Count !== undefined &&
                                                            v[1].bom_alternative_object.Count > 0) &&
                                                            <div className="d-flex align-items-center mt-3">
                                                                <AxiosSingletonLoader
                                                                    overlay={true}
                                                                    slugKey={['PRODUCT_LISTING_API_CALL', 'PRODUCT_PRICING_API_CALL']}
                                                                >
                                                                    <a className="text-blue2"
                                                                        onClick={() => {
                                                                            let p = {};
                                                                            if (v[1].product !== undefined) {
                                                                                p = v[1]
                                                                            }
                                                                            store.dispatch(system_notification({
                                                                                name: 'AlternativeBomPopup',
                                                                                data: {
                                                                                    selected_product: p
                                                                                }
                                                                            }));
                                                                        }}>
                                                                        <i className="fa fa-exchange font-16 ms-2 cursor-pointer text-black me-2"></i>
                                                                        View Alternatives
                                                                    </a>
                                                                </AxiosSingletonLoader>
                                                            </div>
                                                        }
                                                    </td>
                                                    <td>
                                                        {v[1].product !== undefined &&
                                                            <>
                                                                <div className="font-14 font-bold">
                                                                    <a className='cursor-pointer text-wrap text-break'
                                                                        href={Product.getProductDetailPageRouteURLWithCustomParameter(v[1].product) + '?ERPPartNumber=' + v[1].ERPPartNumber + '&ItemNumber=' + v[1].itemNumber}
                                                                        target='_blank'>{v[1].product.ERPMFRPartNumber} </a>
                                                                </div>
                                                                <ShowMoreLess single_product={v[1].product} />
                                                                <div className="sect-row">
                                                                    <span className="datasheet me-0">
                                                                        <span className="lifecycle low-risk"
                                                                            aria-hidden="true"
                                                                            data-toggle="tooltip"
                                                                            data-placement="bottom" data-html="true"
                                                                            data-title="LOW RISK:<br/>Part listed as active by Manufacturer. Suitable for new and existing designs."                                                                        >
                                                                            <DisplayLifeCycleRisk single_product={v[1].product} />
                                                                        </span>
                                                                    </span>
                                                                    {v[1].product.DatasheetUrl ?
                                                                        <span className="datasheet">
                                                                            <a className="datasheet-align img-text mt-0 pt-0 ms-0 text-black"
                                                                                rel="nofollow"
                                                                                href={v[1].product.DatasheetUrl}
                                                                                onClick={() => showDownloadMessage()}
                                                                                title={v[1].product.ManufacturerPartNumber + " Datasheet"}
                                                                                target="_new">
                                                                           <img className='me-1' src={datasheet2} />
                                                                                <span
                                                                                    className='vertical-align-text-top'>Datasheet</span>
                                                                            </a>
                                                                        </span>
                                                                        :
                                                                        ReusableDiv.dataSheetTooltip()
                                                                    }

                                                                </div>
                                                            </>
                                                        }
                                                    </td>
                                                    <td>

                                                        <div className='bomcpn'>
                                                            {
                                                                /**
                                                                 * Author: Trilok
                                                                 * Date : 9/2/2023
                                                                 * Reason: Remove dependency of quantity
                                                                 */
                                                            }
                                                            {/**
                                                         * Send default value for set defalut cpn or manualy add cpn
                                                         * Author: Devanshi Patel
                                                         */}
                                                            {v[1].product !== undefined &&
                                                                <CustomerPartNumberOptions
                                                                    single_product_pricing_list={getPricing(v[1].product.ERPMFRPartNumber, v[1].product.ERPPartNumber, getCPN(v[1]), v[1].cpnTypeName, v[1].ERPPartNumberModified)}
                                                                    single_product_inventory={getInventory(v[1].product.ERPPartNumber)}
                                                                    single_product={v[1].product}
                                                                    bom_detail_id={v[1].bomDetailId}
                                                                    callFrom={Constants.systemModules.BOM}
                                                                    defaultValue={v[1].customerPartNumber}
                                                                    disabled={!_check_p('BOM_ADD_TO_CART').status}
                                                                    updateCpnBom={(SELECTED_CUSTOMER_PART_NUMBER, SELECTED_TYPE) => { updateCpnBom(SELECTED_CUSTOMER_PART_NUMBER, SELECTED_TYPE, v[1]) }}
                                                                    updationCompletedBasedOnUserSelectionOnlyCallback={(SELECTED_CUSTOMER_PART_NUMBER, SELECTED_TYPE) => {
                                                                        if (v[1].customerPartNumber !== SELECTED_CUSTOMER_PART_NUMBER || v[1].cpnTypeName !== SELECTED_TYPE) {
                                                                            let param = {
                                                                                bomDetailId: v[1].bomDetailId,
                                                                                cpnType: SELECTED_TYPE,
                                                                            }
                                                                            param.customerPartNumber = SELECTED_TYPE === Constants.cpnTypes.CPN ? SELECTED_CUSTOMER_PART_NUMBER : v[1].customerPartNumber ? v[1].customerPartNumber : (CART_CUSTOMER_PART_NUMBER_BEFORE_TO_SEND_SERVER[v[1].product.ItemNumber]?.CUSTOMER_PART_NUMBER) ? CART_CUSTOMER_PART_NUMBER_BEFORE_TO_SEND_SERVER[v[1].product.ItemNumber].CUSTOMER_PART_NUMBER : ''
                                                                            param.manualCPN = SELECTED_TYPE === Constants.cpnTypes.MANUALCPN ? SELECTED_CUSTOMER_PART_NUMBER : v[1].manualCPN ? v[1].manualCPN : ''

                                                                            update_customer_part_number_by_bom_detail_by_id(param);
                                                                        }
                                                                    }}
                                                                    displayManualCpn={true}
                                                                    single_cpn_data={v[1]}
                                                                />
                                                            }
                                                        </div>
                                                    </td>
                                                    <td className='text-left'>
                                                        <>
                                                            {v[1].product !== undefined &&
                                                                <>
                                                                    {/**
                                                                 * force_default_quantity sending for display uploaded quantity or added part quantity at default
                                                                 * Author: Devanshi Patel
                                                                 */}
                                                                    <QuantityPicker
                                                                        single_product_pricing_list={getPricing(v[1].product.ERPMFRPartNumber, v[1].product.ERPPartNumber, getCPN(v[1]), v[1].cpnTypeName, v[1].ERPPartNumberModified)}
                                                                        single_product_inventory={getInventory(v[1].product.ERPPartNumber)}
                                                                        single_product={v[1].product}
                                                                        force_default_quantity={v[1].quantity}
                                                                        bom_detail_id={v[1].bomDetailId}
                                                                        disable_increase_decrease={'yes'}
                                                                        is_default_invalid_quantity={checkCartValid(v[1])}
                                                                        disable_edit_force_default_quantity={true}
                                                                        dont_show_invalid_quantity_for_zero_stock={true}
                                                                        dispatch_invalidFlagReduxDispatch={true}
                                                                        getPlanInputQuantityCallback={
                                                                            (q) => SetQuantityUpdateCallbackRunTime({
                                                                                bomDetail: v[1],
                                                                                q
                                                                            })
                                                                        }
                                                                    />
                                                                </>
                                                            }
                                                            {v[1].product === undefined &&
                                                                <>
                                                                    <div className="quantity w-auto clearfix ">
                                                                        <div className="quantity-picker">
                                                                            <div className="bs5 input-group flex-nowrap border-0">
                                                                                <input type="integer"
                                                                                    className="form-control form-control-sm"
                                                                                    value={v[1].quantity}
                                                                                    onChange={() => {
                                                                                    }}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </>
                                                            }
                                                            {v[1].product !== undefined &&
                                                                <div
                                                                    className="text-start small-text light light-text collapse_minmax text-nowrap">
                                                                    <DisplayQtyMinQtyMult
                                                                        single_product={v[1].product}
                                                                    />
                                                                </div>
                                                            }
                                                        </>
                                                    </td>
                                                    <td>
                                                        {v[1].product !== undefined &&
                                                            <>
                                                                {__check(['PRODUCT_PRICING_API_CALL']).status ?
                                                                    <AxiosIndicatorRunTimeLoader /> :
                                                                    <>
                                                                        {validateNonLoginUser() ? <NonLoginSignInButton isAuthAccLess={liveAuth.check() && isGuestFullRights() === false} /> :
                                                                            <>
                                                                                <PriceTable
                                                                                    isDisplayCPN={false}
                                                                                    single_product_inventory={getInventory(v[1].product.ERPPartNumber)}
                                                                                    single_product={v[1].product}
                                                                                    single_product_pricing_list={getPricing(v[1].product.ERPMFRPartNumber, v[1].product.ERPPartNumber, getCPN(v[1]), v[1].cpnTypeName, v[1].ERPPartNumberModified)}
                                                                                />

                                                                                <AddToCart
                                                                                    single_product_pricing_list={getPricing(v[1].product.ERPMFRPartNumber, v[1].product.ERPPartNumber, getCPN(v[1]), v[1].cpnTypeName, v[1].ERPPartNumberModified)}
                                                                                    single_product_inventory={getInventory(v[1].product.ERPPartNumber)}
                                                                                    single_product={v[1].product}
                                                                                    force_default_quantity={v[1].quantity}
                                                                                    disable_increase_decrease={'yes'}
                                                                                    is_default_invalid_quantity={async () => await new BOMRepository().cartValid(v[1].product, getPricing(v[1].product.ERPMFRPartNumber, v[1].product.ERPPartNumber, getCPN(v[1]), v[1].cpnTypeName, v[1].ERPPartNumberModified), getInventory(v[1].product.ERPPartNumber))}
                                                                                    disable_edit_force_default_quantity={true}
                                                                                    do_not_display_add_to_cart_button={true}
                                                                                    CHECK_CART_RELATED_INVENTORY_VALIDATION={true}
                                                                                    trigger_obsolete_and_eol_validation_popup={true}
                                                                                    disable_loader_rendering={true}
                                                                                    selected_cpn={getCPN(v[1])}
                                                                                    isFrom={'BOM'}
                                                                                />
                                                                            </>
                                                                        }
                                                                    </>
                                                                }

                                                            </>
                                                        }
                                                    </td>
                                                    <td>
                                                        {v[1].product !== undefined &&
                                                            <>
                                                                {loadfetchInventoryFromServer || __check(['PRODUCT_INVENTORY_API_CALL']).status ?
                                                                    <AxiosIndicatorRunTimeLoader /> :
                                                                    <>
                                                                        <div className="text-darkgreen  d-flex align-items-center">
                                                                            <span className="d-flex text-darkgreen w-100">
                                                                                <b>In Stock</b>
                                                                                <b className="ms-auto"> {getInventory(v[1].product.ERPPartNumber).quantity} </b>
                                                                                {!__check(['PRODUCT_INVENTORY_API_CALL']).status &&
                                                                                    <i className="fa fa-check-circle ms-2 font-14"></i>
                                                                                }
                                                                            </span>
                                                                        </div>
                                                                        <div id="availability_cont_3_lead_time" className="grey">
                                                                            <div className="addtn-inventory leadTime">
                                                                                <strong>ADDITIONAL INVENTORY</strong>
                                                                                <div className="clearfix">
                                                                                    <FactoryLeadTimeDisplay
                                                                                        single_product={v[1].product}
                                                                                        single_product_inventory={getInventory(v[1].product.ERPPartNumber)} />
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </>
                                                                }
                                                            </>
                                                        }
                                                    </td>
                                                    <td>
                                                        {v[1].product !== undefined &&
                                                            <>{v[1].product.ManufacturerName}</>
                                                        }
                                                        {v[1].product === undefined ||
                                                            v[1].product === null ||
                                                            v[1].product.ManufacturerName === undefined ||
                                                            v[1].product.ManufacturerName === null ||
                                                            v[1].product.ManufacturerName.trim() === '' &&
                                                            <div className='text-center mt-3'>
                                                                -
                                                            </div>
                                                        }
                                                    </td>
                                                    <td>
                                                        <div className='bs5 d-flex'>
                                                            <ul className='d-flex flex-column list-text'>
                                                                <ProductLegends
                                                                    single_product={v[1].product}
                                                                    onlyIconTitle={true}
                                                                />
                                                            </ul>
                                                        </div>
                                                    </td>
                                                    {isInternalUser &&
                                                        <td>
                                                            {v[1]?.product?.DesignWinFlag}
                                                        </td>
                                                    }
                                                </React.Fragment>
                                            }
                                            {v[1].isDeleted === true &&
                                                <>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </>
                                            }
                                            {dynamic_field_activated[bomDetailByBomID.bomId] !== undefined &&
                                                dynamic_field_activated[bomDetailByBomID.bomId] &&
                                                isObject(dynamic_field_activated[bomDetailByBomID.bomId]) &&
                                                Object.entries(dynamic_field_activated[bomDetailByBomID.bomId]).map((v_inner) => (
                                                    <td key={v[1][v_inner[1].columnName] + Helper.UUID()}>
                                                        {v[1][v_inner[1].columnName] !== undefined &&
                                                            v[1][v_inner[1].columnName] !== null &&
                                                            <>
                                                                {v[1][v_inner[1].columnName]}
                                                            </>
                                                        }
                                                        {(v[1][v_inner[1].columnName] === undefined ||
                                                            v[1][v_inner[1].columnName] === null || v[1][v_inner[1].columnName].trim() === '') &&
                                                            <>
                                                                <div className='text-center mt-3'>
                                                                    -
                                                                </div>
                                                            </>
                                                        }
                                                    </td>
                                                )
                                                )}
                                        </tr>
                                    </React.Fragment>
                                ))
                            }
                        </tbody>
                    </table>
                </div>
            </div>
            {displayStatus() && Object.entries(bom_detail_by_bom_id_type.Exact.records).length < (bom_detail_by_bom_id_type.Exact.count + bom_detail_by_bom_id_type.Exact.deleted) &&
                <div className="pagination-row text-center"
                    style={__check(['BOM_TAB_API_CALL', 'BOM_API_CALL', 'CART_API_CALL']).status ? { display: 'none' } : {}}>
                    <button ref={refLoadMore} onClick={() => {
                        SetTop(Common.loadMore(top, props))
                    }} className="bs5 m-t-30 m-b-30 btn btn-secondary w155">Load More
                    </button>
                </div>
            }
            {!(displayStatus() && Object.entries(bom_detail_by_bom_id_type.Exact.records).length < bom_detail_by_bom_id_type.Exact.count) &&
                <div className="pagination-row text-center">
                </div>
            }
        </>
    );
}

export default BomExactMatchTable;